import React from "react";
import "./Footer.css";
import { FaGithub, FaLinkedin, FaArrowUp } from "react-icons/fa";
import { GITHUB, LINKEDIN } from "./siteInfo";

const Footer = () => (
  <footer className="footer">
    <div className="container footer-inner">
      <div>
        <p>
          &copy; {new Date().getFullYear()} Kiran Sable &middot; React Developer in Pune, India
        </p>
        <p className="footer-note">This site records anonymous visit statistics (country, browser, page) to improve the portfolio.</p>
        <nav className="footer-nav" aria-label="Footer">
          <a href="#about">About</a>
          <a href="#skills">Skills</a>
          <a href="#projects">Projects</a>
          <a href="#services">Hire me</a>
          <a href="#contact">Contact</a>
          <a href="/freelance-react-developer">Freelance React developer</a>
          <a href="/hire-react-developer-pune">Hire in Pune</a>
        </nav>
      </div>
      <div className="footer-links">
        <a href={GITHUB} target="_blank" rel="me noopener noreferrer" aria-label="GitHub"><FaGithub /></a>
        <a href={LINKEDIN} target="_blank" rel="me noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
        <a href="#home" aria-label="Back to top"><FaArrowUp /></a>
      </div>
    </div>
  </footer>
);

export default Footer;
